import { render, staticRenderFns } from "./SpuPlatform.vue?vue&type=template&id=4ecc2912&scoped=true"
import script from "./SpuPlatform.vue?vue&type=script&lang=ts"
export * from "./SpuPlatform.vue?vue&type=script&lang=ts"
import style0 from "./SpuPlatform.vue?vue&type=style&index=0&id=4ecc2912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc2912",
  null
  
)

export default component.exports